import React from 'react'
import MediaQuery from 'react-responsive'
import { forOwn } from 'lodash'
import { constants } from 'common/helpers'


/**
 *
 * @param {Object} props
 * @param {Node|Function} props.children
 * @param {Boolean} props.mobile
 * @param {Boolean} props.exceptMobile
 * @constructor
 */
const Media = (props) => {
  const { children, ...rest } = props
  let componentProps = {
    ...rest,
  }

  forOwn(rest, (value, key) => {
    componentProps = {
      ...componentProps,
      ...constants.mediaProps[key],
    }
  })

  forOwn(constants.mediaProps, (value, key) => {
    delete componentProps[key]
  })

  return (
    <MediaQuery {...componentProps}>
      {children}
    </MediaQuery>
  )
}

export default Media
